(function ($) {
    'use strict';
    /**
     * функция сортировки таблицы
     * */
    $.fn.sortsTable = function () {
        var $self = $(this);
        var sortByNameParam = 'sortBy';
        var sortDirNameParam = 'sortDir';
        var pageSizeNameParam = 'pageSize';
        var $sortCellColumn = $self.find('.js-sort-cell');
        var $countPage = $self.find('.js-sort-count-page');
        var $countItem = $countPage.find('.js-sort-count-page-item');
        var sortState = {
            column: '',
            direction: '',
            pageSize: '',
        };
        var SortDirValues = {
            ASC: 'asc',
            DESC: 'desc',
        };

        /**
         * в случае повторного нажатия на тот же столбец возвращает новое направление
         * */
        var reverseSortDirection = function () {
            if (sortState.direction === SortDirValues.DESC) {
                return SortDirValues.ASC;
            }
            return SortDirValues.DESC;
        };

        /**
         * создает и возвращает новый URL
         * @direction - принимает направление сортировки
         * */
        var getUrlByState = function (currentUrl) {
            currentUrl.searchParams.set(sortByNameParam, sortState.column);
            currentUrl.searchParams.set(sortDirNameParam, sortState.direction);
            return currentUrl.href;
        };

        /**
         * перекрашивает активный столбец ( по которому проводится сортировка)
         * */
        var highlightsSelectedColumn = function () {
            $sortCellColumn.each(function () {
                if ($(this).data('name') === sortState.column) {
                    $(this).addClass('active');
                }
            });
        };

        /**
         * переключает стрелочки в шапке таблицы
         * */
        var switchClassSortCeil = function () {
            $('.js-sort-through-backend').each(function () {
                if ($(this).data('name') === sortState.column) {
                    $(this).addClass(sortState.direction);
                }
            });
        };

        var emitSortColumn = function () {
            if (sortState.column && sortState.column.length > 0) {
                highlightsSelectedColumn();
                switchClassSortCeil();
            }
        };

        var clearActiveClassCountItems = function () {
            $countItem.each(function () {
                $(this).removeClass('active');
            });
        };

        var addCountItemActiveClass = function (count) {
            $countItem.each(function () {
                if ($(this).data('count').toString() === count.toString()) {
                    $(this).addClass('active');
                }
            });
        };

        var addStartPageSize = function () {
            var currentUrl = new URL(window.location.href);
            sortState.pageSize = currentUrl.searchParams.get(pageSizeNameParam);
            if (!sortState.pageSize) {
                sortState.pageSize = 50;
            }
            addCountItemActiveClass(sortState.pageSize);
        };

        var addHandlerInCountItem = function () {
            $countItem.on('click', function () {
                clearActiveClassCountItems();
                $(this).addClass('active');
                sortState.pageSize = $(this).data('count');
                var currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set(sortByNameParam, sortState.column);
                currentUrl.searchParams.set(pageSizeNameParam, sortState.pageSize);
                window.location = getUrlByState(currentUrl);
            });
        }

        /**
         * инициализация
         * */
        var init = function () {
            var currentUrl = new URL(window.location.href);

            sortState.column = currentUrl.searchParams.get(sortByNameParam);
            sortState.direction = currentUrl.searchParams.get(sortDirNameParam);
            addStartPageSize();

           $('#cup-stats-pjax').on('pjax:success', function () {
               $sortCellColumn = $self.find('.js-sort-cell');
               $countPage = $self.find('.js-sort-count-page');
               $countItem = $countPage.find('.js-sort-count-page-item');
               addStartPageSize();
               emitSortColumn();
               addHandlerInCountItem();
               window.scrollTo(0, 0);
            });

           $('#tournament-stats-pjax').on('pjax:success', function () {
               $sortCellColumn = $self.find('.js-sort-cell');
               $countPage = $self.find('.js-sort-count-page');
               $countItem = $countPage.find('.js-sort-count-page-item');
               addStartPageSize();
               emitSortColumn();
               addHandlerInCountItem();
               window.scrollTo(0, 0);
           });

           emitSortColumn();

           addHandlerInCountItem();

            $self.on('click', '.js-sort-through-backend', function () {
                var currentUrl = new URL(window.location.href);
                var columnName = $(this).attr('data-name');
                var reverse = $(this).hasClass('reverse');

                currentUrl.searchParams.set(sortByNameParam, columnName);
                currentUrl.searchParams.set(pageSizeNameParam, sortState.pageSize);

                if (reverse) {
                    sortState.direction = sortState.column === columnName ? reverseSortDirection() :  SortDirValues.ASC;
                } else {
                    sortState.direction = sortState.column === columnName ? reverseSortDirection() :  SortDirValues.DESC;
                }

                sortState.column = columnName;
                window.location = getUrlByState(currentUrl);
            });
        };

        init();
        return this;
    };

    $('.js-sorts-table').each(function () {
        $(this).data('sortsTable', $(this).sortsTable());
    });
})(jQuery);
